import React from 'react';  
  
const Loader = ({ message = 'Loading...' }) => {  
  return (  
    <div className="loader-container">  
      <div className="loader"></div>  
      {message && <p style={{ marginTop: '20px', color: 'var(--text-secondary)' }}>{message}</p>}  
    </div>  
  );  
};  
  
export default Loader;  

